/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ComponentsButtonComponent } from './ComponentsButtonComponent'
import type { UploadFile } from './UploadFile'
export type SectionsHeroComponent = {
  id?: number
  __component?: string
  title?: string
  content?: string
  visual?: UploadFile
  buttons?: Array<ComponentsButtonComponent>
  style?: SectionsHeroComponent.style
}
export namespace SectionsHeroComponent {
  export enum style {
    PRIMARY = 'Primary',
    SECONDARY = 'Secondary',
    TERTIARY = 'Tertiary',
    WHITE = 'White',
  }
}
